import { render, staticRenderFns } from "./GdprTermsDeniedOverlay.vue?vue&type=template&id=7a9573d3&"
import script from "./GdprTermsDeniedOverlay.js?vue&type=script&lang=js&"
export * from "./GdprTermsDeniedOverlay.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a9573d3')) {
      api.createRecord('7a9573d3', component.options)
    } else {
      api.reload('7a9573d3', component.options)
    }
    module.hot.accept("./GdprTermsDeniedOverlay.vue?vue&type=template&id=7a9573d3&", function () {
      api.rerender('7a9573d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/GdprTermsDeniedOverlay/GdprTermsDeniedOverlay.vue"
export default component.exports